import classNames from 'classnames';
import React from 'react';
import styles from './PulsatingCircle.module.css';

// eslint-disable-next-line react/require-default-props
function PulsatingCircle({ className, small }: { className: string, small?: boolean }) {
  return (
    <div className={classNames(
      styles.pulsatingCircle,
      {
        [styles.circleSmall]: small,
      },
      className,
    )}
    />
  );
}

export default PulsatingCircle;
